import {
  CreateGUFClosureRealisedPartTask,
  EditGUFClosureRealisedPartTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

export const realisedWellClosurePartSchema = addSchema<
  (
    | CreateGUFClosureRealisedPartTask
    | EditGUFClosureRealisedPartTask
  )["sourcedocumentData"]["realisedWells"]
>({
  type: "array",
  title: "Gerealiseerde putten",
  minItems: 0,
  items: {
    type: "object",
    title: "Gerealiseerde put",
    required: ["realisedWellId"],
    properties: pickGufPrimitiveLibraryFields(["realisedWellId"]),
  },
});
